<template>
    <div>

        <vue-headful title="Disciplinary Violations :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light"><i class="fa fa-cogs"></i> Admin</li>
                <li class="breadcrumb-item active">Disciplinary Violations</li>
                <li class="ml-3">
                    <router-link :to="`/admin/disciplinary-violations/create`" class="btn btn-sm btn-success"><i class="fa fa-plus"></i> New</router-link>
                </li>
            </ol>
        </h4>

        <div class="card">
            <div class="card-body">
                <v-server-table ref="hseTypeTable" url="/admin/disciplinary-violations" :columns="columns" :options="options">

                    <router-link slot="disc_violation_id" slot-scope="props" :to="`/admin/disciplinary-violations/edit/${props.row.disc_violation_id}`" title="Edit Violation" class="btn btn-sm btn-light">
                        <i class="fa fa-edit"></i> Edit
                    </router-link>

                </v-server-table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                columns: ['disc_violation_id', 'violation_name', 'penalty_name', 'bonus_disqual_time'],
                options: {
                    headings: {
                        disc_violation_id: 'Edit',
                        violation_name: 'Violation',
                        penalty_name: 'Penalty',
                        bonus_disqual_time: 'Safety Bonus Disqualification',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'disciplinary_violations.violation_name',
                    },
                    uniqueKey: 'disc_violation_id',
                },
            }
        },

        methods: {

        },
    }
</script>
